import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography, CircularProgress } from '@mui/material';
import {
  setNetworkError,
  setNetworkConnection,
} from '../../store/slices/statusSlice';

function NetworkTest({ roomClient }) {
  const [testing, setTesting] = useState(true);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const setupTest = useCallback(async () => {
    try {
      return await roomClient.test();
    } catch (e) {
      // Map unknown errors to predefined error types
      let errorType = e.message;
      const knownErrors = [
        'tokenError',
        'socketError',
        'streamError',
        'streamingError',
        'unexpectedError',
      ];

      if (!knownErrors.includes(e.message)) {
        errorType = 'unexpectedError';
      }

      dispatch(setNetworkError(errorType));
      return {};
    }
  }, [dispatch, roomClient]);

  useEffect(() => {
    (async () => {
      const { status } = await setupTest();
      dispatch(setNetworkConnection(status));
      setTesting(false);
    })();
  }, [dispatch, setupTest]);

  if (testing) {
    return (
      <Grid item sx={{ width: '100%' }}>
        <Box display="flex" justifyContent="center" margin="16px">
          <CircularProgress
            color="primary"
            aria-label={t('Testing network connection')}
            role="progressbar"
          />
        </Box>
        <Box sx={{ maxWidth: '375px' }} role="status" aria-live="polite">
          <Typography
            variant="subtitle1"
            gutterBottom
            align="center"
            fontSize="14px"
          >
            {t(
              'Please wait while we check your network condition. It should be completed within 10-15 seconds.'
            )}
          </Typography>
        </Box>
      </Grid>
    );
  }
}

export default NetworkTest;
